"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_EchoStack_OnAbilityUsedEventHandlerScript = void 0;
const Registries_1 = require("../../core/state/Registries");
let Effect_EchoStack_OnAbilityUsedEventHandlerScript = class Effect_EchoStack_OnAbilityUsedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__typeName !== "AbilityUsed") {
            return;
        }
        else if (handler.meta.consumed) {
            return;
        }
        handler.meta.consumed = true;
        for (let i = 0; i < handler.args.scriptArgs.count; i++) {
            if (container.isDeceased(handler.subject)) {
                return;
            }
            // short circuit if there are no living targets for the ability to hit.
            const livingTargets = container.selectLivingTargets(handler.subject, event.args.args.target);
            if (livingTargets.length === 0) {
                return;
            }
            container.useAbility(sequence, handler.subject, event.args.args, false);
        }
    }
};
Effect_EchoStack_OnAbilityUsedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_EchoStack_OnAbilityUsed")
], Effect_EchoStack_OnAbilityUsedEventHandlerScript);
exports.Effect_EchoStack_OnAbilityUsedEventHandlerScript = Effect_EchoStack_OnAbilityUsedEventHandlerScript;
